

































































































import { Component, Vue } from 'vue-property-decorator'
import { Route, Location } from 'vue-router'

import BookingCard from '@/components/BookingCard.vue'
import LargeAvatar from '@/components/LargeAvatar.vue'
import LoadingPlaceholder from '@/components/LoadingPlaceholder.vue'
import ProfileInfo from '@/components/ProfileInfo.vue'

import Booking from '@/models/booking'
import Customer from '@/models/customer'

import store from '@/store'
import {
  BookingsActionTypes,
  BookingsMutationTypes,
} from '@/store/modules/bookings'

@Component({
  components: {
    ProfileInfo,
    BookingCard,
    LargeAvatar,
    LoadingPlaceholder,
  },
})
export default class Dashboard extends Vue {
  bookingScopes = ['active', 'past', 'expired']
  navigationFolded = true

  beforeRouteEnter(to: Route, from: Route, next: (to?: Location) => void) {
    store.dispatch(BookingsActionTypes.Load)
    next()
  }

  get bookingsLoaded(): boolean {
    return this.$store.state.bookings.bookingsLoaded
  }

  get bookings(): Booking[] {
    return this.$store.getters.getBookings
  }

  get bookingsByScope(): { [scope: string]: Booking[] } {
    const result: { [scope: string]: Booking[] } = {}

    this.bookingScopes.forEach((scope) => {
      result[scope] = this.filterByScope(
        scope,
        this.$store.getters.getBookingsByScope(scope),
      )
    })

    return result
  }

  get customer() {
    return this.$store.getters.getCurrentCustomer
  }

  get bookingsScope() {
    return this.$store.getters.getBookingsScope
  }

  get loaderHeight(): number {
    return window.innerWidth > 400 ? 143 : 268
  }

  customerFor(booking: Booking): Customer | null {
    if (this.customer.id === booking.customerId) {
      return null
    }

    return this.$store.getters.getCustomerById(booking.customerId)
  }

  onBookingScopeChange(scope: string) {
    this.navigationFolded = !this.navigationFolded
    this.$store.commit(BookingsMutationTypes.ScopeChange, scope)
  }

  filterByScope(scope: string, bookings: Booking[]): Booking[] {
    if (scope === 'active') {
      return bookings.sort(
        (booking1, booking2) =>
          (new Date(booking1.departAt) as any) -
          (new Date(booking2.departAt) as any),
      )
    } else if (scope === 'expired') {
      return bookings.sort(
        (booking1, booking2) =>
          (new Date(booking2.expire) as any) -
          (new Date(booking1.expire) as any),
      )
    } else {
      return bookings.sort(
        (booking1, booking2) =>
          (new Date(booking2.departAt) as any) -
          (new Date(booking1.departAt) as any),
      )
    }
  }
}
